import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,

  state: {
    teachers: [],
    selectedTeacher: null,
    filter: {
      name: null,
      gender: null,
      subject: null,
      schoolSystem: null
    }
  },
  mutations,
  actions,
  getters
};

export default store;
